import { render, staticRenderFns } from "./DashboardGestaoRowEvolucao.vue?vue&type=template&id=16338d0b&scoped=true"
import script from "./DashboardGestaoRowEvolucao.vue?vue&type=script&lang=js"
export * from "./DashboardGestaoRowEvolucao.vue?vue&type=script&lang=js"
import style0 from "./DashboardGestaoRowEvolucao.vue?vue&type=style&index=0&id=16338d0b&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16338d0b",
  null
  
)

export default component.exports